module.exports = __webpack_public_path__ + "img/81.1.34620ef5.jpg";